import { useState, type ReactNode } from 'react'

interface SidebarProps {
  children: ReactNode
}

export function Sidebar({ children }: SidebarProps) {
  const [collapsed, setCollapsed] = useState(false)

  return (
    <div
      className={`bg-white border-r border-gray-200 flex flex-col transition-all duration-200 ${
        collapsed ? 'w-0 overflow-hidden' : 'w-80'
      }`}
    >
      <button
        onClick={() => setCollapsed(!collapsed)}
        className="absolute top-14 z-[1000] bg-white border border-gray-300 rounded-r-md px-1 py-2 text-gray-500 hover:text-gray-700 shadow-sm"
        style={{ left: collapsed ? 0 : '320px' }}
        title={collapsed ? 'Show sidebar' : 'Hide sidebar'}
      >
        {collapsed ? '\u25B6' : '\u25C0'}
      </button>

      {!collapsed && (
        <div className="flex-1 overflow-y-auto">
          {children}
        </div>
      )}
    </div>
  )
}
